import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./components/header/Navbar";
import Footer from "./components/footer/Footer";
import Copyright from "./components/copyright/Copyright";

const Layout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      <Copyright />
    </>
  );
};

export default Layout;
